import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { siteConfig } from '../data';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Forside', path: '/' },
    { name: 'Behandling', path: '/behandling/integrativ-massageterapi' },
    { name: 'Om Trine', path: '/om-trine' },
    { name: 'Praktisk info', path: '/praktisk' },
    { name: 'Kontakt', path: '/kontakt' },
  ];

  return (
    <header 
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? 'py-4 bg-stone-50/95 backdrop-blur-md shadow-sm border-b border-stone-200/50' : 'py-6 bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4 md:px-6">
        <nav className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group shrink-0">
            <img 
              src="/imgi_1_fav_Logo.png" 
              alt="MassageterapiCPH Logo" 
              className="w-8 h-8 md:w-9 lg:w-10 md:h-9 lg:h-10 object-contain transition-transform duration-500 group-hover:rotate-12"
            />
            <div className="flex flex-col">
              <span className="text-lg md:text-base lg:text-xl font-light tracking-widest text-stone-900 uppercase leading-none">
                Massageterapi <span className="font-serif italic lowercase tracking-normal">CPH</span>
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center lg:space-x-8 xl:space-x-10">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-xs uppercase tracking-widest transition-colors duration-300 ${
                  location.pathname === link.path
                    ? 'text-stone-900 font-medium'
                    : 'text-stone-500 hover:text-stone-900'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href={siteConfig.bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-stone-900 text-stone-50 px-6 py-2.5 text-xs uppercase tracking-widest hover:bg-stone-800 transition-all duration-300 shadow-sm whitespace-nowrap"
            >
              Book tid
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-stone-800 p-2"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle menu"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </nav>
      </div>

      {/* Mobile Navigation */}
      <div
        className={`fixed inset-0 bg-white z-40 transition-transform duration-300 transform ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        } lg:hidden flex flex-col justify-center items-center`}
      >
        <div className="absolute top-0 left-0 right-0 p-6 flex justify-between items-center">
          <Link to="/" className="flex items-center gap-2" onClick={() => setIsOpen(false)}>
            <img 
              src="/imgi_1_fav_Logo.png" 
              alt="MassageterapiCPH Logo" 
              className="w-8 h-8 object-contain"
            />
            <span className="text-sm font-light tracking-widest text-stone-800 uppercase leading-none">
              Massageterapi CPH
            </span>
          </Link>
          <button
            className="text-stone-800 p-2"
            onClick={() => setIsOpen(false)}
            aria-label="Close menu"
          >
            <X size={32} />
          </button>
        </div>
        <div className="flex flex-col space-y-8 text-center">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-2xl font-light tracking-wide ${
                location.pathname === link.path ? 'text-stone-900' : 'text-stone-500'
              }`}
              onClick={() => setIsOpen(false)}
            >
              {link.name}
            </Link>
          ))}
          <a
            href={siteConfig.bookingUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-stone-800 text-stone-50 px-10 py-4 text-lg tracking-wide inline-block"
            onClick={() => setIsOpen(false)}
          >
            Book tid
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
